<template>
    <div class="video-container">
        <ResanehSwiper :list="favList" type="Video"/>

        <div class="result">
            <ResanehNav :type="type" @changeType="changeType"/>

            <div class="row">
                <template v-if="List.length != 0">
                    <div class="col-6 col-md-4 col-lg-3 item" v-for="(item, index) in List" :key="index">
                        <div class="inner-container">
                            <div
                                class="inner-item"
                                :style="{ 'background-image': 'url(' + URL + '/' + item.img + ')' }"
                                @click="fullscreenChange(item.file)"
                            ></div>

                            <!-- LIKE -->
                            <i 
                                v-if="LikeList.indexOf(item.id) > -1" @click="removePod(item.id)"
                                class="fas fa-heart icon-font unlike-pod"
                            ></i>
                            <i v-else class="fas fa-heart icon-font like-pod" @click="addPod(item.id)"></i>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <h5 class="empty">موردی یافت نگردید</h5>
                </template>
            </div>
        </div>

        <fullscreen :fullscreen.sync="showFS" class="fullscreen">
            <a class="close-btn" @click="() => { this.showFS = false}">
                <i class="far fa-times" aria-hidden="true"></i>
            </a>
            <video 
                id="video" class="video-inner"
                v-if="showFS"
                controls
                controlsList="nodownload"
                autoplay
            >
                <source
                    v-if="File"
                    :src="URL + '/' + File" 
                    type="video/mp4"
                >
                Your browser does not support the video tag.
            </video>
        </fullscreen>
    </div>
</template>

<script>
import ResanehNav from '@/layout/ResanehNav.vue';
import ResanehSwiper from '@/components/ResanehSwiper.vue';

import { getRequest, postRequest, APP_API_URL } from '@/utils/libs/api-request';
import Cookies from 'js-cookie';

export default {
    name: 'Video',
    data() {
        return {
            type: 'all',
            URL: APP_API_URL(),

            List: [],
            File: undefined,
            favList: [],
            showFS: false,
            LikeList: [],
        }
    },
    mounted() {
        this.GetList();
        this.GetFavs();
        this.GetLikeList();
    },
    methods: {
        removePod(id) {
            postRequest('/users/unbook-items', {
                isPodcast: false,
                itemId: id
            })
                .then(() => {
                    // response
                    this.GetLikeList();
                })
                .catch(() => {
                    // error
                });
        },
        addPod(id) {
            postRequest('/users/book-items', {
                isPodcast: false,
                itemId: id
            })
                .then(() => {
                    // response
                    this.GetLikeList();
                })
                .catch(() => {
                    // error
                });
        },
        GetLikeList() {
            getRequest('/users/user')
                .then(rsp => {
                    // response
                    this.LikeList = rsp['data'].BookedVideos;
                })
                .catch(() => {
                    // error
                });
        },

        fullscreenChange(file) {
            this.File = file;
            this.showFS = !this.showFS;
        },
        changeType(type) {
            this.type = type;
            this.GetList()
        },
        GetList() {
            getRequest('/videos/find-' + this.type)
                .then(rsp => {
                    // response
                    let data = rsp.data;
                    this.List = [];
                    data.forEach(item => {
                        this.List.push({
                            file: item.File,
                            id: item._id,
                            title: item.Title,
                            img: item.Cover,
                        })
                    });
                })
                .catch(err => {
                    // check auth
                    if (err.response) {
                        if (err.response.status == 401) {
                            Cookies.remove('access_cookie');
                            this.$router.push({ name: 'Login' });
                        }
                    }
                });
        },        
        GetFavs() {
            getRequest('/videos/find-favorites')
                .then(rsp => {
                    // response
                    let data = rsp.data;
                    data.forEach(item => {
                        this.favList.push({
                            id: item._id,
                            name: 'VideoDetails',
                            file: item.File,
                            view: item.View,
                            title: item.Title,
                            img: item.Cover,
                        })
                    });
                })
                .catch(err => {
                    // check auth
                    if (err.response) {
                        if (err.response.status == 401) {
                            Cookies.remove('access_cookie');
                            this.$router.push({ name: 'Login' });
                        }
                    }
                });
        },
    },
    components: {
        ResanehNav,
        ResanehSwiper
    }
}
</script>

<style scoped>
.video-container .icon-font {
    position: absolute;
    top: 0;
    left: 0;
    padding: 20px;
}
.video-container .like-pod,
.video-container .unlike-pod{
    font-size: 1.5rem !important;
}
.video-container .like-pod {
    color: #fff;
}
.video-container .unlike-pod {
    color: #f10000;
}

/* ---------------------------------------- */
/* ---------------- RESULT  --------------- */
/* ---------------------------------------- */
.result {
    margin-top: -9vh;
    padding: 0 15pt 5vh;

    position: relative;
    z-index: 1;

    border-radius: 9vh;
    background-color: #ebecf1;
}
.result .empty {
    width: 100%;
    margin: 30pt auto;

    text-align: center;
}
.result .item {
    height: 100%;
    width: 100%;

    margin-bottom: 5pt;
    padding: 0 5pt;
}
.result .item .inner-container {
    height: 100%;
    width: 100%;

    padding: 7pt;
    border: 1px solid #ffffff;
    border-radius: 20pt;
    box-shadow: inset 4.2px 4.2px 3px 0 #cecece;
}
.result .item .inner-container .inner-item {
    height: 64vw;
    width: 100%;

    border-radius: 15pt;
    /* background-color: #242427; */
    /* box-shadow: 4.2px 4.2px 3px 0 #24242744; */
    border: 1px solid #cfcfcf;
    background-color: #fff;
    box-shadow: 4.2px 4.2px 3px 0 #24242744;

    text-align: center;
    cursor: pointer;

    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

/* ---------------------------------------- */
/* -------------- RESPONSIVE -------------- */
/* ---------------------------------------- */
@media (max-width: 576px) {
    .result .item {
        padding: 0 2pt;
    }
    .result .item .inner-container {
        padding: 5pt;
    }
}

/* ---------------------------------------- */
/* -------------- FULL SCREEN ------------- */
/* ---------------------------------------- */
.fullscreen {
    display: flex;
    position: relative;
    color: #fff;
}
.fullscreen .close-btn {
  position: absolute;
  top: 5pt;
  right: 10pt;
  z-index: 1;

  font-size: 2rem;
  cursor: pointer;
}
.fullscreen .video-inner{
    height: 100%;
    width: 100%;
    margin: auto;
    background-color: #000;
}
</style>